<template>
  <!--下拉详情-->
  <div class="main">
    <section class="main-wrap">
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          公司名称：<span>{{ details.companyName }}</span>
        </el-col>
        <el-col :span="16" class="address">
          公司地址：<span>{{ details.companyAddress }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          客户姓名：<span>{{ details.customerName }}</span>
        </el-col>
        <el-col :span="8" class="address">
          客户电话：<span>{{ details.customerPhone }}</span>
        </el-col>
        <el-col :span="8" class="address">
          固定电话：<span>{{ details.fixTelphone }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          客户类别：
          <span v-if="details.customerType==1">svip</span>
          <span v-if="details.customerType==2">vip</span>
          <span v-if="details.customerType==3">普通客户</span>
          <span v-if="details.customerType==4">老客户</span>
          <span v-if="details.customerType==5">合作伙伴</span>
        </el-col>
        <el-col :span="8" class="address">
          是否业务客户：
          <span v-if="details.isBusiness==1" style="color: #BE2316">否</span>
          <span v-if="details.isBusiness==2" style="color: #BE2316">是</span>
        </el-col>
        <el-col :span="8" class="address">
          客户成熟度：
          <span v-if="details.customerMaturity==1">明确成交意向</span>
          <span v-if="details.customerMaturity==2">有初步成交意向</span>
          <span v-if="details.customerMaturity==3">关键人有成交意向</span>
          <span v-if="details.customerMaturity==4">关键人成交,意向不确定</span>
          <span v-if="details.customerMaturity==5">初步联系，有意向</span>
          <span v-if="details.customerMaturity==6">初步联系，意向不确定</span>
          <span v-if="details.customerMaturity==7">新建客户</span>
          <span v-if="details.customerMaturity==8">明显拒绝</span>
          <span v-if="details.customerMaturity==9">无效客户</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          建立时间：<span>{{ details.createDate }}</span>
        </el-col>
        <el-col :span="16" class="address">
          跟进时间：<span>{{ details.followDate }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="24" class="address item-remarks">
          备注：<span>{{ details.remarks }}</span>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .main-wrap{
    padding: 25px 20px 0px 20px;
    border-top: 1px solid #DBDDE1;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    transition: all 0.8s ease-in-out;
    animation: show 0.8s ease-in-out;

    .main-item{
      font-size: 14px;
      padding-bottom: 25px;
      .item-remarks{
        color: #BE2316;
        span{
          color: #000;
          word-wrap:break-word;
        }
      }
    }
  }
</style>
